import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {FormControl} from "@angular/forms";
import {Subscription} from "rxjs";
import {UserSubscription, UserSubscriptionCategory, UserSubscriptionType} from "../../../../user/user-subscription";
import {User} from "../../../../user/user";
import {WorkspaceService} from "../../../workspace.service";

@Component({
    selector: 'db-payment-method',
    templateUrl: './payment-method.component.html',
    styleUrls: ['./payment-method.component.scss'],
    standalone: false
})
export class PaymentMethodComponent implements OnInit, AfterViewInit {
    @Input() userSubscription?: UserSubscription;
    @Input() checkout?: any;
    @Input() stripe?: any;
    @Input() isPayPalProvider?: boolean;
    @Input() confirmPayPalPayment?: () => Promise<{ success: boolean; error?: string }>;
    @Output() onPaymentMethodSubmit = new EventEmitter();
    @Output() onLoadingChange = new EventEmitter<boolean>();

    public UserSubscriptionCategory: any = UserSubscriptionCategory;
    public subscriptions: Subscription[];
    public stripeErrors: any;
    public paymentMethod: FormControl;
    public UserSubscriptionType: any = UserSubscriptionType;
    public user: User;
    public loadingStripe: boolean = true;
    public loadingConfirm: boolean;
    public paymentElement: any;
    public paypalApproved: boolean = false;

    constructor(private _workspaceService: WorkspaceService) {
    }

    ngOnInit(): void {
        console.log('PaymentMethodComponent ngOnInit');
        console.log('isPayPalProvider:', this.isPayPalProvider);
    }

    ngAfterViewInit(): void {
        // Wait for the view to be fully initialized before mounting Stripe elements
        this.initPayment();
    }

    public async initPayment() {
        try {
            if (this.isPayPalProvider) {
                // PayPal flow - fields are rendered from billing.component.ts
                this.loadingStripe = false;
                this.onLoadingChange.emit(false);
            } else {
                // Stripe flow
                const paymentElementContainer = document.getElementById('payment-element');

                // Check if the DOM element exists before mounting
                if (!paymentElementContainer) {
                    console.error('Payment element container not found in DOM');
                    this.loadingStripe = false;
                    this.onLoadingChange.emit(false);
                    return;
                }

                this.paymentElement = this.checkout.create('payment');
                if (this.paymentElement) {
                    // Listen for the ready event to confirm element is mounted
                    this.paymentElement.on('ready', () => {
                        this.loadingStripe = false;
                        this.onLoadingChange.emit(false);
                    });

                    await this.paymentElement.mount('#payment-element');
                } else {
                    this.loadingStripe = false;
                    this.onLoadingChange.emit(false);
                }
            }
        } catch (error) {
            console.error('Error in initPayment:', error);
            this.loadingStripe = false;
            this.onLoadingChange.emit(false);
        }
    }


    public async confirm() {
        try {
            this.loadingConfirm = true;
            this.stripeErrors = null;

            if (this.isPayPalProvider) {

                if (!this.confirmPayPalPayment) {
                    this.stripeErrors = 'Payment system not initialized. Please try again.';
                    this.loadingConfirm = false;
                    return;
                }
                const result = await this.confirmPayPalPayment();
                if (result.success) {
                    this.onPaymentMethodSubmit.emit();
                } else {
                    this.stripeErrors = result.error || 'Payment failed. Please try again.';
                }
                this.loadingConfirm = false;
            } else {
                // Stripe flow
                const result = await this.stripe.confirmSetup({
                    elements: this.checkout,
                    confirmParams: {
                        return_url: `${window.location.origin}/?payment-complete`,
                    },
                    redirect: "if_required",
                });

                if (result.error) {
                    this.stripeErrors = result.error.message;
                    this.loadingConfirm = false;
                } else {
                    this.onPaymentMethodSubmit.emit();
                    this.loadingConfirm = false;
                }
            }
        } catch (error) {
            console.error('Error confirming payment:', error);
            this.loadingConfirm = false;
        }
    }
}
